import { render, staticRenderFns } from "./classical-admin-evaluation-suggestion.vue?vue&type=template&id=0735aa37&scoped=true"
import script from "./classical-admin-evaluation-suggestion.vue?vue&type=script&lang=js"
export * from "./classical-admin-evaluation-suggestion.vue?vue&type=script&lang=js"
import style0 from "./classical-admin-evaluation-suggestion.vue?vue&type=style&index=0&id=0735aa37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0735aa37",
  null
  
)

export default component.exports